import e from "react";

var r = e.createContext(),
    t = function t(_t) {
  return e.createElement(r.Provider, {
    value: _t.theme
  }, _t.children);
};

export { r as ThemeContext, t as ThemeProvider };